import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'recompose';
import moment from 'moment';

import { querySelector } from '../../../utils';
import queryMetaHandler from '../../../utils/queryMetaHandler';
import omitProps from '../../../utils/omitProps';


const GetAllBonusMonths = gql`
  query GetAllBonusMonthsQuery {
    all_month_bonuses{
      edges {
        node {
          id
          month {
            month
            display
            iso8601
            month_year_display
          }
        }
      }
    }
  }
`;

const marshallData = ({ data, ownProps }) => {
  const result = querySelector(data, '$.all_month_bonuses.edges[*].node', []);

  const allBonusMonths = result.map((item) => {
    const tempObject = Object.assign({}, item.month);
    tempObject.abvMonth = moment(item.month.iso8601).format('MMM');
    return tempObject;
  });
  return {
    ...ownProps,
    data,
    allBonusMonths,
  };
};

const queryGetAllBonusMonthsData = graphql(GetAllBonusMonths, {
  props: marshallData,
  options: {
    fetchPolicy: 'network-only',
  },
});

export const queryGetAllBonusMonthsGQL = compose(
  queryGetAllBonusMonthsData,
  queryMetaHandler,
  omitProps(['data']),
);
